import Vue from 'vue';
import Router from 'vue-router';
import OpenHome from './views/OpenHome.vue';

Vue.use(Router);

export default new Router({
	mode: 'history',
	base: 'open',
	routes: [{
			path: '/',
			name: 'home',
			component: OpenHome
		},
		{
			path: '/map-member/:code',
			name: 'mamMember',
			component: () => import('./views/open/MapMember.vue')
		},
		{
			path: '/map-member',
			name: 'mamMember',
			component: () => import('./views/open/MapMember.vue')
		},
		{
			path: '/signup',
			name: 'signUp',
			component: () => import('./views/open/SignUp.vue')
		}
	]
});